// src/pages/locations/components/form/FormActions.tsx
import React from "react";
import { FiAlertCircle } from "react-icons/fi";

/** Summary shown above the fields when a save fails or validation blocks it. */
export const FormError: React.FC<{ message?: string | null }> = ({ message }) =>
  message ? (
    <div
      role="alert"
      className="mx-5 mt-5 flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-xs text-red-700 sm:mx-6"
    >
      <FiAlertCircle className="mt-0.5 shrink-0" />
      <span>{message}</span>
    </div>
  ) : null;

const Spinner: React.FC = () => (
  <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/60 border-t-transparent" />
);

export const FormActions: React.FC<{
  submitLabel: string;
  submittingLabel: string;
  isSubmitting: boolean;
  onCancel: () => void;
  /** Create screens only: save and stay for the next record. */
  onSaveAndAddAnother?: () => void;
}> = ({
  submitLabel,
  submittingLabel,
  isSubmitting,
  onCancel,
  onSaveAndAddAnother,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-3 rounded-b-2xl border-t border-gray-200 bg-gray-50/70 px-5 py-4 sm:px-6">
    <div>
      {onSaveAndAddAnother && (
        <button
          type="button"
          onClick={onSaveAndAddAnother}
          disabled={isSubmitting}
          className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60"
        >
          Save &amp; add another
        </button>
      )}
    </div>

    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onCancel}
        disabled={isSubmitting}
        className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-60"
      >
        Cancel
      </button>

      <button
        type="submit"
        disabled={isSubmitting}
        className="inline-flex items-center gap-2 rounded-lg bg-sky-600 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-700 disabled:opacity-60"
      >
        {isSubmitting && <Spinner />}
        {isSubmitting ? submittingLabel : submitLabel}
      </button>
    </div>
  </div>
);
